import { useClassified } from "@/contexts/classified";
import { addIconToCoOwnershipItems } from "./addIconToItem";
export const useCoOwnership = () => {
    var _a, _b, _c, _d;
    const items = (_d = (_c = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.sections) === null || _b === void 0 ? void 0 : _b.coOwnership) === null || _c === void 0 ? void 0 : _c.items) !== null && _d !== void 0 ? _d : [];
    const itemsWithIcon = addIconToCoOwnershipItems(items);
    // @ts-ignore
    return [...itemsWithIcon];
};
